import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  ST_INQUIRIES_PROOF_OF_STUDY_CREATE,
  ST_INQUIRIES_PROOF_OF_STUDY_LIST,
} from '../constants/actionTypes'

const studentInquiriesSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const stInquiriesProofOfStudyCreateSelector = createSelector(
  studentInquiriesSelectors,
  data => data[ST_INQUIRIES_PROOF_OF_STUDY_CREATE]
)

export const stInquiriesProofOfStudyListSelector = createSelector(
  studentInquiriesSelectors,
  data => data[ST_INQUIRIES_PROOF_OF_STUDY_LIST]
)
